






import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { AUTH_GET_CLIENT, AUTH_GET_COUNTRY, AUTH_GET_VEHICLETYPE } from '@/store/modules/authentication/types';
import { Client } from '@/store/modules/authentication/interfaces';

import { traceLogAccess } from '@/services';
import { ContextEnum } from '@/enums/context.enum';
import { ClientEnum } from '@/enums/client.enum';
import { TupleDictionary } from '@/utils/tupleDictionary';

import ReportPowerBiContainer from '../../components/report-powerbi-container/report-powerbi-container.vue';
import { CountryEnum, CountryType } from '@/enums/country.enum';
import PbiDictWorkspaceId, { PbiWorkspacesEnum } from '@/modules/neodash/containers/powerbi/pbi-dict-workspace-id';
import { VehicleTypeEnum } from '@/enums/vehicle-type.enum';

@Component({
  name: 'PbiSalesRegistrationEffectivenessPage',
  components: { ReportPowerBiContainer }
})
export default class PbiSalesRegistrationEffectivenessPage extends Vue {
  @Getter(AUTH_GET_CLIENT)
  public client: Client;

  @Getter(AUTH_GET_COUNTRY)
  public country: CountryType;

  @Getter(AUTH_GET_VEHICLETYPE)
  public idVehicleType: number;

  private pbiDictWorkspaceId = new PbiDictWorkspaceId();

  public dictReports = new TupleDictionary<[ClientEnum, VehicleTypeEnum, CountryType], IPbiContainer>();
  public crrReport: IPbiContainer = { brand: '', workspaceId: '', reportId: '' };

  mounted() {
    // EQUADOR
    this.dictReports.set([ClientEnum.Hyundai, VehicleTypeEnum.Car, CountryEnum.Equador], { brand: 'Hyundai', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: 'e550b500-da0f-4537-8561-9df636bcc82f' });

    // COLOMBIA
    this.dictReports.set([ClientEnum.Hyundai, VehicleTypeEnum.Car, CountryEnum.Colombia], { brand: 'Hyundai', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: 'ac95b0fc-2905-4fd5-9b77-d78c0034ac02' });

    // URUGUAI
    this.dictReports.set([ClientEnum.Hyundai, VehicleTypeEnum.Car, CountryEnum.Uruguai], { brand: 'Hyundai', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: '529b2b06-1b3e-4cc3-b103-ce3a30688638' })

    // CHILE
    this.dictReports.set([ClientEnum.Hyundai, VehicleTypeEnum.Car, CountryEnum.Chile], { brand: 'Hyundai', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: '59522197-1a68-45e4-a0ab-cd51ca3eb567' })

    this.crrReport = this.dictReports.get([this.client.id, this.idVehicleType, this.country]);
    traceLogAccess.logAction(ContextEnum.Report, `${this.crrReport.brand} - Sales x Registration Effectiveness`);
  }
}
